import React, { Component } from "react";
import { ToggleControl } from '@wordpress/components';


class TriggerProduct extends Component {

    constructor(props) {
        super(props);
    }



    render() {

        const { attributes: {triggerProduct}, setAttributes } = this.props;

        const changeFunction = (value) => {
            setAttributes({
                triggerProduct: value
            });
        }

        return (
            <div className="components-base-control">
                <div className="components-base-control__field">
                    <label className="components-base-control__label">Auto-trigger the payment form</label>
                    <ToggleControl
                        checked={ triggerProduct }
                        onChange={ changeFunction }
                    />
                </div>
            </div>
        );

    }
}


export default TriggerProduct;